const DEFAULT_APP_LAYOUT = {
	layoutType: 'vertical',
	mode: 'light',
	visibility: 'show',
	layoutWidth: 'fluid',
	position: 'fixed',
	topbar: 'light',
	sidebarSize: 'lg',
	sidebarView: 'default',
	sidebarColor: 'gradient-4',
	sidebarImage: 'none',
	preloader: 'disable',
};

export const APP_THEME_PRESETS = [
	{
		key: 'pearl-sky',
		label: '珍珠天藍 Pearl Sky',
		palette: {
			primary: '#2f92d0',
			secondary: '#7b8fa3',
			success: '#42b883',
			info: '#4fc0d7',
			warning: '#d9a441',
			danger: '#d66a6a',
			light: '#f5fbff',
			dark: '#52687d',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #2f92d0 0%, #4fc0d7 100%)',
			'gradient-2': 'linear-gradient(135deg, #428ed9 0%, #5ac6d9 100%)',
			'gradient-3': 'linear-gradient(135deg, #557ed8 0%, #45b4d6 100%)',
			'gradient-4':
				'linear-gradient(135deg, #2f92d0 0%, #4fc0d7 58%, #6aa6e8 100%)',
		},
	},
	{
		key: 'glacier-blue',
		label: '冰河藍 Glacier Blue',
		palette: {
			primary: '#4f84e6',
			secondary: '#778aa1',
			success: '#42b883',
			info: '#55bee3',
			warning: '#d9ac50',
			danger: '#d96b73',
			light: '#f5f9ff',
			dark: '#58687f',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #4f84e6 0%, #55bee3 100%)',
			'gradient-2': 'linear-gradient(135deg, #5e73df 0%, #4f9ee6 100%)',
			'gradient-3': 'linear-gradient(135deg, #4f84e6 0%, #66c7d4 100%)',
			'gradient-4':
				'linear-gradient(135deg, #4f84e6 0%, #55bee3 56%, #7c9df2 100%)',
		},
	},
	{
		key: 'aurora-teal',
		label: '極光青 Aurora Teal',
		palette: {
			primary: '#1fa6a8',
			secondary: '#748d91',
			success: '#36b77c',
			info: '#52c7bd',
			warning: '#d8a845',
			danger: '#d66d70',
			light: '#f3fbfa',
			dark: '#557078',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #1fa6a8 0%, #52c7bd 100%)',
			'gradient-2': 'linear-gradient(135deg, #2096c5 0%, #39bfa8 100%)',
			'gradient-3': 'linear-gradient(135deg, #35a4c8 0%, #36b77c 100%)',
			'gradient-4':
				'linear-gradient(135deg, #1fa6a8 0%, #52c7bd 58%, #70aee6 100%)',
		},
	},
	{
		key: 'jade-mint',
		label: '晶玉綠 Jade Mint',
		palette: {
			primary: '#32a56f',
			secondary: '#788b7f',
			success: '#48bd7a',
			info: '#5dc7aa',
			warning: '#d7a445',
			danger: '#d66a6a',
			light: '#f4fbf6',
			dark: '#5a7567',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #32a56f 0%, #5dc7aa 100%)',
			'gradient-2': 'linear-gradient(135deg, #43a869 0%, #69c78e 100%)',
			'gradient-3': 'linear-gradient(135deg, #2fae94 0%, #48bd7a 100%)',
			'gradient-4':
				'linear-gradient(135deg, #32a56f 0%, #55c58d 58%, #63bfd0 100%)',
		},
	},
	{
		key: 'lavender-mist',
		label: '薰衣紫 Lavender Mist',
		palette: {
			primary: '#7d69d9',
			secondary: '#867f9c',
			success: '#45b981',
			info: '#9d87e8',
			warning: '#d7a74b',
			danger: '#d96d83',
			light: '#f8f6ff',
			dark: '#6a607f',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #7d69d9 0%, #9d87e8 100%)',
			'gradient-2': 'linear-gradient(135deg, #6d78df 0%, #9d87e8 100%)',
			'gradient-3': 'linear-gradient(135deg, #7d69d9 0%, #58b6db 100%)',
			'gradient-4':
				'linear-gradient(135deg, #7d69d9 0%, #9d87e8 58%, #6fb7e8 100%)',
		},
	},
	{
		key: 'rose-quartz',
		label: '玫瑰晶 Rose Quartz',
		palette: {
			primary: '#d86f8d',
			secondary: '#928086',
			success: '#4eb982',
			info: '#e38aaa',
			warning: '#d8a74e',
			danger: '#d66d70',
			light: '#fff6f9',
			dark: '#78616b',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #d86f8d 0%, #e38aaa 100%)',
			'gradient-2': 'linear-gradient(135deg, #c967a0 0%, #e38aaa 100%)',
			'gradient-3': 'linear-gradient(135deg, #d86f8d 0%, #9d87e8 100%)',
			'gradient-4':
				'linear-gradient(135deg, #d86f8d 0%, #e38aaa 58%, #b985e8 100%)',
		},
	},
	{
		key: 'champagne-gold',
		label: '香檳金 Champagne Gold',
		palette: {
			primary: '#c7943d',
			secondary: '#8b846f',
			success: '#58af76',
			info: '#73b9d8',
			warning: '#dfa84c',
			danger: '#d66b6b',
			light: '#fffaf0',
			dark: '#776950',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #c7943d 0%, #d7aa52 100%)',
			'gradient-2': 'linear-gradient(135deg, #b88a3a 0%, #73b9d8 100%)',
			'gradient-3': 'linear-gradient(135deg, #c7943d 0%, #58af76 100%)',
			'gradient-4':
				'linear-gradient(135deg, #b88734 0%, #d7aa52 55%, #67aacf 100%)',
		},
	},
	{
		key: 'coral-sunrise',
		label: '珊瑚曦光 Coral Sunrise',
		palette: {
			primary: '#df765f',
			secondary: '#8f817b',
			success: '#4fb37f',
			info: '#67bde0',
			warning: '#e2a249',
			danger: '#d86069',
			light: '#fff7f3',
			dark: '#765f58',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #df765f 0%, #f09a72 100%)',
			'gradient-2': 'linear-gradient(135deg, #d66a6a 0%, #df9a5f 100%)',
			'gradient-3': 'linear-gradient(135deg, #df765f 0%, #67bde0 100%)',
			'gradient-4':
				'linear-gradient(135deg, #d76858 0%, #e78e66 55%, #61aed8 100%)',
		},
	},
	{
		key: 'porcelain-indigo',
		label: '瓷釉靛 Porcelain Indigo',
		palette: {
			primary: '#5c78e5',
			secondary: '#7d879b',
			success: '#4ab57e',
			info: '#6fb4ee',
			warning: '#d5aa4c',
			danger: '#d76b7a',
			light: '#f6f8ff',
			dark: '#5d6881',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #5c78e5 0%, #6fb4ee 100%)',
			'gradient-2': 'linear-gradient(135deg, #6a6fe6 0%, #6fb4ee 100%)',
			'gradient-3': 'linear-gradient(135deg, #5c78e5 0%, #78c6d7 100%)',
			'gradient-4':
				'linear-gradient(135deg, #5c78e5 0%, #6fb4ee 58%, #8f8df0 100%)',
		},
	},
	{
		key: 'sage-lime',
		label: '檸霧綠 Sage Lime',
		palette: {
			primary: '#68ad5b',
			secondary: '#7f8d78',
			success: '#62bd77',
			info: '#69c6c0',
			warning: '#d3a84d',
			danger: '#d66b6b',
			light: '#f7fbf3',
			dark: '#627457',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #68ad5b 0%, #69c6c0 100%)',
			'gradient-2': 'linear-gradient(135deg, #77b653 0%, #65b98b 100%)',
			'gradient-3': 'linear-gradient(135deg, #68ad5b 0%, #61aed8 100%)',
			'gradient-4':
				'linear-gradient(135deg, #68ad5b 0%, #7fc468 56%, #69c6c0 100%)',
		},
	},
	{
		key: 'dusk-harbor',
		label: '暮海藍 Dusk Harbor',
		palette: {
			primary: '#3f6f8f',
			secondary: '#758594',
			success: '#4c9b7a',
			info: '#5c8fa8',
			warning: '#c49a54',
			danger: '#bf6a6c',
			light: '#f3f7f9',
			dark: '#4b6172',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #3f6f8f 0%, #5c8fa8 100%)',
			'gradient-2': 'linear-gradient(135deg, #456b86 0%, #6a8397 100%)',
			'gradient-3': 'linear-gradient(135deg, #3f6f8f 0%, #4c9b7a 100%)',
			'gradient-4':
				'linear-gradient(135deg, #3f6f8f 0%, #5c8fa8 58%, #7a8db0 100%)',
		},
	},
	{
		key: 'midnight-teal',
		label: '松石夜 Midnight Teal',
		palette: {
			primary: '#2f7c83',
			secondary: '#71878a',
			success: '#4aa078',
			info: '#4b969d',
			warning: '#c6a051',
			danger: '#c26a70',
			light: '#f2f8f8',
			dark: '#4b6c70',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #2f7c83 0%, #4b969d 100%)',
			'gradient-2': 'linear-gradient(135deg, #346f78 0%, #598c90 100%)',
			'gradient-3': 'linear-gradient(135deg, #2f7c83 0%, #4aa078 100%)',
			'gradient-4':
				'linear-gradient(135deg, #2f7c83 0%, #4b969d 58%, #6b8ea0 100%)',
		},
	},
	{
		key: 'deep-sage',
		label: '深鼠尾草 Deep Sage',
		palette: {
			primary: '#5f8063',
			secondary: '#778476',
			success: '#6a9a65',
			info: '#6f928d',
			warning: '#c4a05c',
			danger: '#bf6d68',
			light: '#f5f8f3',
			dark: '#596d59',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #5f8063 0%, #7b986f 100%)',
			'gradient-2': 'linear-gradient(135deg, #607760 0%, #7f8e71 100%)',
			'gradient-3': 'linear-gradient(135deg, #5f8063 0%, #6f928d 100%)',
			'gradient-4':
				'linear-gradient(135deg, #5f8063 0%, #7b986f 56%, #6f928d 100%)',
		},
	},
	{
		key: 'cocoa-bronze',
		label: '古銅棕 Cocoa Bronze',
		palette: {
			primary: '#8b704f',
			secondary: '#877d70',
			success: '#73915f',
			info: '#7f8fa5',
			warning: '#c79b55',
			danger: '#bd6d63',
			light: '#faf7f1',
			dark: '#736454',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #8b704f 0%, #a98556 100%)',
			'gradient-2': 'linear-gradient(135deg, #806a52 0%, #9b8066 100%)',
			'gradient-3': 'linear-gradient(135deg, #8b704f 0%, #7f8fa5 100%)',
			'gradient-4':
				'linear-gradient(135deg, #80684b 0%, #a98556 55%, #758da0 100%)',
		},
	},
	{
		key: 'garnet-wine',
		label: '石榴酒紅 Garnet Wine',
		palette: {
			primary: '#9a596a',
			secondary: '#87777e',
			success: '#5e9673',
			info: '#aa7188',
			warning: '#c39d57',
			danger: '#c36570',
			light: '#faf4f6',
			dark: '#745d66',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #9a596a 0%, #aa7188 100%)',
			'gradient-2': 'linear-gradient(135deg, #8d536b 0%, #a46d7c 100%)',
			'gradient-3': 'linear-gradient(135deg, #9a596a 0%, #7f8fa5 100%)',
			'gradient-4':
				'linear-gradient(135deg, #9a596a 0%, #aa7188 58%, #836f9c 100%)',
		},
	},
	{
		key: 'smoked-plum',
		label: '煙紫 Smoked Plum',
		palette: {
			primary: '#76648f',
			secondary: '#817b8b',
			success: '#699779',
			info: '#907ca6',
			warning: '#c19c58',
			danger: '#bd6b78',
			light: '#f8f6fb',
			dark: '#675d75',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #76648f 0%, #907ca6 100%)',
			'gradient-2': 'linear-gradient(135deg, #6b668e 0%, #827ca0 100%)',
			'gradient-3': 'linear-gradient(135deg, #76648f 0%, #6f8da4 100%)',
			'gradient-4':
				'linear-gradient(135deg, #76648f 0%, #907ca6 56%, #6f8da4 100%)',
		},
	},
	{
		key: 'mineral-blue',
		label: '礦岩藍 Mineral Blue',
		palette: {
			primary: '#58758f',
			secondary: '#7a8590',
			success: '#5c9877',
			info: '#6c91a8',
			warning: '#c49c58',
			danger: '#bf6d72',
			light: '#f4f7fa',
			dark: '#5b6876',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #58758f 0%, #6c91a8 100%)',
			'gradient-2': 'linear-gradient(135deg, #566f89 0%, #76899b 100%)',
			'gradient-3': 'linear-gradient(135deg, #58758f 0%, #5c9877 100%)',
			'gradient-4':
				'linear-gradient(135deg, #58758f 0%, #6c91a8 58%, #7f86a4 100%)',
		},
	},
	{
		key: 'olive-ash',
		label: '橄欖灰 Olive Ash',
		palette: {
			primary: '#777f58',
			secondary: '#828776',
			success: '#75935f',
			info: '#7f9995',
			warning: '#c7a15a',
			danger: '#bd7068',
			light: '#f8f8f1',
			dark: '#676c58',
		},
		sidebarGradients: {
			gradient: 'linear-gradient(135deg, #777f58 0%, #909866 100%)',
			'gradient-2': 'linear-gradient(135deg, #70795a 0%, #878b6d 100%)',
			'gradient-3': 'linear-gradient(135deg, #777f58 0%, #7f9995 100%)',
			'gradient-4':
				'linear-gradient(135deg, #777f58 0%, #909866 56%, #7f9995 100%)',
		},
	},
];

const expandHex = value => {
	const normalized = value.replace('#', '').trim();
	if (normalized.length === 3) {
		return normalized
			.split('')
			.map(part => part + part)
			.join('');
	}
	return normalized;
};

const hexToRgb = value => {
	const normalized = expandHex(value);
	return {
		r: Number.parseInt(normalized.slice(0, 2), 16),
		g: Number.parseInt(normalized.slice(2, 4), 16),
		b: Number.parseInt(normalized.slice(4, 6), 16),
	};
};

const rgbString = value => {
	const { r, g, b } = hexToRgb(value);
	return `${r}, ${g}, ${b}`;
};

const mixHex = (from, to, weight) => {
	const start = hexToRgb(from);
	const end = hexToRgb(to);
	const mix = channel =>
		Math.round(start[channel] + (end[channel] - start[channel]) * weight)
			.toString(16)
			.padStart(2, '0');
	return `#${mix('r')}${mix('g')}${mix('b')}`;
};

const tintHex = (value, weight) => mixHex(value, '#ffffff', weight);
const shadeHex = (value, weight) => mixHex(value, '#28445f', weight);
const rgba = (value, alpha) => `rgba(${rgbString(value)}, ${alpha})`;

const getContrastColor = value => {
	const { r, g, b } = hexToRgb(value);
	const luminance = (r * 299 + g * 587 + b * 114) / 1000;
	return luminance >= 160 ? '#112027' : '#ffffff';
};

const buildTokenCss = (tokenName, color) => {
	const contrast = getContrastColor(color);
	const hover = shadeHex(color, 0.08);
	const active = shadeHex(color, 0.14);
	const subtle = tintHex(color, 0.86);
	const subtleBorder = tintHex(color, 0.7);
	const subtleText = shadeHex(color, 0.22);
	const focusShadow = rgbString(color);

	return `
.text-${tokenName} {
	color: rgba(var(--bs-${tokenName}-rgb), var(--bs-text-opacity, 1)) !important;
}

.link-${tokenName} {
	color: ${color} !important;
}

.link-${tokenName}:hover,
.link-${tokenName}:focus {
	color: ${hover} !important;
}

.bg-${tokenName} {
	background-color: rgba(var(--bs-${tokenName}-rgb), var(--bs-bg-opacity, 1)) !important;
}

.border-${tokenName} {
	border-color: rgba(var(--bs-${tokenName}-rgb), var(--bs-border-opacity, 1)) !important;
}

.bg-${tokenName}-subtle {
	background-color: ${subtle} !important;
}

.border-${tokenName}-subtle {
	border-color: ${subtleBorder} !important;
}

.text-bg-${tokenName} {
	color: ${contrast} !important;
	background-color: ${color} !important;
}

.btn-${tokenName} {
	--bs-btn-color: ${contrast};
	--bs-btn-bg: ${color};
	--bs-btn-border-color: ${color};
	--bs-btn-hover-color: ${contrast};
	--bs-btn-hover-bg: ${hover};
	--bs-btn-hover-border-color: ${hover};
	--bs-btn-focus-shadow-rgb: ${focusShadow};
	--bs-btn-active-color: ${contrast};
	--bs-btn-active-bg: ${active};
	--bs-btn-active-border-color: ${active};
	--bs-btn-disabled-color: ${contrast};
	--bs-btn-disabled-bg: ${color};
	--bs-btn-disabled-border-color: ${color};
}

.btn-outline-${tokenName} {
	--bs-btn-color: ${color};
	--bs-btn-border-color: ${color};
	--bs-btn-hover-color: ${contrast};
	--bs-btn-hover-bg: ${color};
	--bs-btn-hover-border-color: ${color};
	--bs-btn-focus-shadow-rgb: ${focusShadow};
	--bs-btn-active-color: ${contrast};
	--bs-btn-active-bg: ${active};
	--bs-btn-active-border-color: ${active};
	--bs-btn-disabled-color: ${color};
	--bs-btn-disabled-bg: transparent;
	--bs-btn-disabled-border-color: ${color};
}

.btn-soft-${tokenName} {
	background-color: ${rgba(color, 0.14)} !important;
	border-color: transparent !important;
	color: ${color} !important;
}

.btn-soft-${tokenName}:hover,
.btn-soft-${tokenName}:focus,
.btn-soft-${tokenName}:active {
	background-color: ${rgba(color, 0.22)} !important;
	border-color: transparent !important;
	color: ${color} !important;
}

.btn-ghost-${tokenName} {
	background-color: transparent !important;
	border-color: transparent !important;
	color: ${color} !important;
}

.btn-ghost-${tokenName}:hover,
.btn-ghost-${tokenName}:focus,
.btn-ghost-${tokenName}:active {
	background-color: ${rgba(color, 0.12)} !important;
	border-color: transparent !important;
	color: ${color} !important;
}

.alert-${tokenName} {
	--bs-alert-color: ${subtleText};
	--bs-alert-bg: ${subtle};
	--bs-alert-border-color: ${subtleBorder};
}
`;
};

const buildRuntimeThemeCss = preset => {
	const { palette, sidebarGradients } = preset;
	const rootVars = Object.entries(palette)
		.map(([tokenName, color]) => {
			const rgb = rgbString(color);
			return `
	--vz-${tokenName}: ${color};
	--vz-${tokenName}-rgb: ${rgb};
	--bs-${tokenName}: ${color};
	--bs-${tokenName}-rgb: ${rgb};`;
		})
		.join('');

	const tokenCss = [
		'primary',
		'secondary',
		'success',
		'info',
		'warning',
		'danger',
	]
		.map(tokenName => buildTokenCss(tokenName, palette[tokenName]))
		.join('\n');

	return `
:root {
	${rootVars}
	--vz-header-bg: #ffffff;
	--vz-header-border: #e9ebec;
	--vz-header-item-color: #495057;
	--vz-header-item-bg: rgba(53, 119, 241, 0.12);
	--vz-header-item-sub-color: #878a99;
	--vz-topbar-search-bg: #f3f3f9;
	--vz-topbar-search-color: #495057;
	--vz-topbar-user-bg: #f3f3f9;
	--bs-theme: ${palette.primary};
	--bs-theme-rgb: ${rgbString(palette.primary)};
	--bs-theme-color: #ffffff;
	--bs-theme-color-rgb: 255, 255, 255;
	--bs-link-color: ${palette.primary};
	--bs-link-hover-color: ${shadeHex(palette.primary, 0.12)};
	--vz-vertical-menu-item-hover-color: ${palette.primary};
	--vz-vertical-menu-item-active-color: ${palette.primary};
	--vz-vertical-menu-item-active-bg: ${rgba(palette.primary, 0.15)};
	--vz-vertical-menu-sub-item-hover-color: ${palette.primary};
	--vz-vertical-menu-sub-item-active-color: ${palette.primary};
	--vz-topnav-item-active-color: ${palette.primary};
	--vz-dark-header-bg: ${palette.primary};
	--vz-dark-header-border: ${palette.primary};
	--vz-dark-header-item-bg: ${shadeHex(palette.primary, 0.1)};
	--vz-dark-topbar-user-bg: ${shadeHex(palette.primary, 0.06)};
}

:root[data-sidebar='dark'] {
	--vz-vertical-menu-bg: ${palette.primary};
	--vz-vertical-menu-border: ${palette.primary};
	--vz-vertical-menu-item-color: rgba(255, 255, 255, 0.78);
	--vz-vertical-menu-item-bg: rgba(255, 255, 255, 0.15);
	--vz-vertical-menu-item-hover-color: #ffffff;
	--vz-vertical-menu-item-active-color: #ffffff;
	--vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.18);
	--vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.72);
	--vz-vertical-menu-sub-item-hover-color: #ffffff;
	--vz-vertical-menu-sub-item-active-color: #ffffff;
	--vz-vertical-menu-title-color: rgba(255, 255, 255, 0.55);
	--vz-twocolumn-menu-iconview-bg: ${tintHex(palette.primary, 0.04)};
}

:root:is([data-sidebar='gradient'], [data-sidebar='gradient-2'], [data-sidebar='gradient-3'], [data-sidebar='gradient-4']) {
	--vz-header-bg: #ffffff;
	--vz-header-border: #e9ebec;
	--vz-header-item-color: #495057;
	--vz-header-item-bg: rgba(53, 119, 241, 0.12);
	--vz-header-item-sub-color: #878a99;
	--vz-topbar-search-bg: #f3f3f9;
	--vz-topbar-search-color: #495057;
	--vz-topbar-user-bg: #f3f3f9;
	--vz-vertical-menu-item-color: rgba(255, 255, 255, 0.74);
	--vz-vertical-menu-item-bg: rgba(255, 255, 255, 0.14);
	--vz-vertical-menu-item-hover-color: #ffffff;
	--vz-vertical-menu-item-active-color: #ffffff;
	--vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.18);
	--vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.72);
	--vz-vertical-menu-sub-item-hover-color: #ffffff;
	--vz-vertical-menu-sub-item-active-color: #ffffff;
	--vz-vertical-menu-title-color: rgba(255, 255, 255, 0.55);
	--vz-vertical-menu-box-shadow: 0 2px 10px rgba(15, 34, 58, 0.12);
	--vz-vertical-menu-dropdown-box-shadow: 0 2px 10px rgba(15, 34, 58, 0.12);
}

:root[data-sidebar='gradient'] {
	--vz-vertical-menu-bg: ${sidebarGradients.gradient};
	--vz-vertical-menu-border: ${palette.info};
	--vz-twocolumn-menu-iconview-bg: ${palette.primary};
}

:root[data-sidebar='gradient-2'] {
	--vz-vertical-menu-bg: ${sidebarGradients['gradient-2']};
	--vz-vertical-menu-border: ${palette.secondary};
	--vz-twocolumn-menu-iconview-bg: ${palette.info};
}

:root[data-sidebar='gradient-3'] {
	--vz-vertical-menu-bg: ${sidebarGradients['gradient-3']};
	--vz-vertical-menu-border: ${palette.success};
	--vz-twocolumn-menu-iconview-bg: ${palette.secondary};
}

:root[data-sidebar='gradient-4'] {
	--vz-vertical-menu-bg: ${sidebarGradients['gradient-4']};
	--vz-vertical-menu-border: ${palette.primary};
	--vz-twocolumn-menu-iconview-bg: ${palette.dark};
}

${tokenCss}
`;
};

const applyRuntimeThemeStyles = preset => {
	if (typeof document === 'undefined') {
		return;
	}
	const styleId = `${preset.appId}-runtime-theme`;
	let styleTag = document.getElementById(styleId);
	if (!styleTag) {
		styleTag = document.createElement('style');
		styleTag.id = styleId;
		document.head.appendChild(styleTag);
	}
	styleTag.textContent = buildRuntimeThemeCss(preset);
};

const applyAppThemeDocumentAttributes = preset => {
	if (typeof document === 'undefined') {
		return;
	}
	document.documentElement.setAttribute('data-app-theme', preset.appId);
	document.documentElement.setAttribute('data-app-theme-palette', preset.key);
	document.documentElement.setAttribute(
		'data-bs-theme',
		preset.layout.mode === 'dark' ? 'dark' : 'light'
	);
};

export const createAppThemeModule = ({
	appId,
	storageKey,
	defaultThemeKey = 'pearl-sky',
	defaultLayout = {},
}) => {
	const baseAppTheme = {
		appId,
		themeMode: 'light',
		layout: {
			...DEFAULT_APP_LAYOUT,
			...defaultLayout,
		},
		palette: {},
		sidebarGradients: {},
	};

	const appThemeOptions = APP_THEME_PRESETS.map(theme => ({
		...baseAppTheme,
		...theme,
		appId,
		layout: {
			...baseAppTheme.layout,
			...(theme.layout || {}),
		},
	}));

	const findAppThemePreset = key =>
		appThemeOptions.find(theme => theme.key === key) ||
		appThemeOptions.find(theme => theme.key === defaultThemeKey) ||
		appThemeOptions[0];

	const loadAppThemeKey = () => {
		if (typeof window === 'undefined') {
			return defaultThemeKey;
		}
		const storedThemeKey = window.localStorage.getItem(storageKey);
		return findAppThemePreset(storedThemeKey).key;
	};

	const saveAppThemeKey = themeKey => {
		if (typeof window !== 'undefined') {
			window.localStorage.setItem(storageKey, themeKey);
		}
	};

	const getDefaultThemeState = () => {
		const defaultAppTheme = findAppThemePreset(loadAppThemeKey());
		return {
			name: null,
			themeMode: defaultAppTheme.themeMode,
			appThemeKey: defaultAppTheme.key,
			velzonTheme: {
				...defaultAppTheme.layout,
			},
		};
	};

	return {
		namespaced: false,
		state: getDefaultThemeState(),
		getters: {
			getTheme(state) {
				console.log('store theme, state.name=' + state.name);
				return state.name;
			},
			getAppThemeOptions() {
				return appThemeOptions;
			},
			getAppThemeKey(state) {
				return findAppThemePreset(
					state.appThemeKey || loadAppThemeKey()
				).key;
			},
			getAppThemePreset(state) {
				return findAppThemePreset(
					state.appThemeKey || loadAppThemeKey()
				);
			},
		},
		mutations: {
			resetTheme(state) {
				console.log('store, theme, mutations: reset state');
				Object.assign(state, getDefaultThemeState());
			},
			changeTheme(state, value) {
				console.log('store theme, value=' + value);
				state.name = value;
			},
			setAppThemeKey(state, themeKey) {
				state.appThemeKey = findAppThemePreset(themeKey).key;
			},
			setVelzonTheme(state, theme) {
				state.velzonTheme = {
					...state.velzonTheme,
					...theme,
				};
			},
			setThemeMode(state, mode) {
				const normalizedMode = mode === 'dark' ? 'dark' : 'light';
				console.log('store theme, setThemeMode=' + normalizedMode);
				state.themeMode = normalizedMode;
				state.velzonTheme = {
					...state.velzonTheme,
					mode: normalizedMode,
				};
				if (typeof document !== 'undefined') {
					document.documentElement.setAttribute(
						'data-bs-theme',
						normalizedMode
					);
					document.body?.setAttribute('data-theme', normalizedMode);
				}
			},
		},
		actions: {
			resetTheme({ commit, dispatch, state }) {
				commit('resetTheme');
				dispatch('applySelectedAppTheme', {
					themeKey: state.appThemeKey,
					mode: state.themeMode,
				});
			},
			initTheme({ dispatch, state }) {
				dispatch('applySelectedAppTheme', {
					themeKey: state.appThemeKey || loadAppThemeKey(),
					mode: state.themeMode,
				});
			},
			changeThemeMode({ commit, dispatch }, mode) {
				commit('setThemeMode', mode);
				dispatch('layout/changeMode', { mode }, { root: true });
			},
			changeAppTheme({ dispatch, state }, themeKey) {
				dispatch('applySelectedAppTheme', {
					themeKey,
					mode: state.themeMode,
				});
			},
			applySelectedAppTheme({ commit, dispatch, state }, payload) {
				const themeKey =
					typeof payload === 'string' ? payload : payload?.themeKey;
				const preset = findAppThemePreset(themeKey);
				const mode =
					(typeof payload === 'object' ? payload?.mode : state.themeMode) ===
					'dark'
						? 'dark'
						: 'light';
				const effectivePreset = {
					...preset,
					layout: {
						...preset.layout,
						mode,
					},
				};
				commit('setAppThemeKey', preset.key);
				commit('setVelzonTheme', effectivePreset.layout);
				commit('setThemeMode', mode);
				applyRuntimeThemeStyles(effectivePreset);
				applyAppThemeDocumentAttributes(effectivePreset);
				saveAppThemeKey(preset.key);
				dispatch('applyVelzonTheme');
			},
			applyVelzonTheme({ dispatch, state }) {
				const theme = state.velzonTheme;
				dispatch(
					'layout/changeLayoutType',
					{ layoutType: theme.layoutType },
					{ root: true }
				);
				dispatch(
					'layout/changeMode',
					{ mode: theme.mode },
					{ root: true }
				);
				dispatch(
					'layout/changeVisibility',
					{ visibility: theme.visibility },
					{ root: true }
				);
				dispatch(
					'layout/changeLayoutWidth',
					{ layoutWidth: theme.layoutWidth },
					{ root: true }
				);
				dispatch(
					'layout/changePosition',
					{ position: theme.position },
					{ root: true }
				);
				dispatch(
					'layout/changeTopbar',
					{ topbar: theme.topbar },
					{ root: true }
				);
				dispatch(
					'layout/changeSidebarSize',
					{ sidebarSize: theme.sidebarSize },
					{ root: true }
				);
				dispatch(
					'layout/changeSidebarView',
					{ sidebarView: theme.sidebarView },
					{ root: true }
				);
				dispatch(
					'layout/changeSidebarColor',
					{ sidebarColor: theme.sidebarColor },
					{ root: true }
				);
				dispatch(
					'layout/changeSidebarImage',
					{ sidebarImage: theme.sidebarImage },
					{ root: true }
				);
				dispatch(
					'layout/changePreloader',
					{ preloader: theme.preloader },
					{ root: true }
				);
			},
		},
	};
};
